/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type WorkflowSchemeConfigEntrypointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const workflowSchemeConfigEntrypoint: EntryPoint<
	WorkflowSchemeConfigEntrypointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForInteraction<WorkflowSchemeConfigEntrypointComponent>(
		/* webpackChunkName: "async-project-settings-workflow-scheme-config", jiraSpaEntry: "async-project-settings-workflow-scheme-config" */ './index.tsx',
	),
	getPreloadProps: () => ({}),
});
